import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import { CaseItem } from '@type/buzzkuri/programs-categor'
import React from 'react'

type Props = {
  caseItem: CaseItem
}

export const CategoryCaseContentItem = ({ caseItem }: Props): JSX.Element => {
  const { id, imagePath, businessName, title } = caseItem
  return (
    <div className="flex flex-col lg:flex-row">
      <div className="w-[74.9vw] lg:w-[17.6vw]">
        <ImageWraper
          className="rounded-[15px]"
          src={imagePath}
          width={225}
          height={112}
        />
      </div>
      <div className="flex flex-col mt-[8vw] lg:mt-0 lg:ml-[2.7vw] lg:w-[33.2vw]">
        <div className="font-hiragino text-[4.3vw] lg:text-[1.3vw] text-[#707070]">
          {businessName}
        </div>
        <div className="lg:my-[1.6vw] mt-[4vw] mb-[5.5vw] w-[8vw] lg:w-[3.1vw] border-b"></div>
        <div className="font-hiragino text-[3.7vw] lg:text-[1.1vw] font-bold lg:hover:opacity-50">
          <a href={`/cases/${id}`}>{title} </a>
        </div>
      </div>
    </div>
  )
}
